jQuery(function ($) {
	var svgMarker = {
		url:
			"data:image/svg+xml;charset=UTF-8," +
			encodeURIComponent(
				'<svg width="49" height="72" viewBox="0 0 49 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.044 35.6455H48.2317C48.2317 35.6487 48.2317 35.6518 48.2317 35.655C48.2312 35.6569 48.2302 35.6596 48.2288 35.6629C48.2274 35.6662 48.2256 35.67 48.2235 35.674L29.8325 71.238C29.8258 71.2506 29.8159 71.2612 29.8037 71.2686C29.7915 71.276 29.7775 71.2799 29.7633 71.28C28.366 71.2855 26.484 71.2882 24.1172 71.2882C21.7495 71.2882 19.8671 71.2855 18.4698 71.28C18.4555 71.2799 18.4415 71.276 18.4294 71.2686C18.4172 71.2612 18.4072 71.2506 18.4006 71.238L0.0081474 35.6754C0.00607308 35.6713 0.00426749 35.6675 0.00286484 35.6643C0.00146219 35.661 0.000486167 35.6583 0 35.6564C0 35.6527 0 35.6491 0 35.6455H10.9391C10.939 35.6464 10.939 35.6473 10.939 35.6482C10.939 35.6548 10.9405 35.6613 10.9435 35.6672L15.3212 44.6098C15.3259 44.6195 15.3341 44.627 15.3442 44.6308C15.3543 44.6346 15.3655 44.6343 15.3754 44.6301L37.0169 35.6876C37.0249 35.6845 37.0318 35.6792 37.0366 35.6721C37.0415 35.6651 37.0441 35.6568 37.0441 35.6482C37.0441 35.6473 37.044 35.6464 37.044 35.6455ZM19.5293 53.0992C19.5236 53.1016 19.5185 53.105 19.5143 53.1094C19.51 53.1138 19.5067 53.119 19.5045 53.1247C19.5024 53.1305 19.5014 53.1366 19.5017 53.1427C19.502 53.1488 19.5035 53.1548 19.5062 53.1603L23.9978 62.3348C24.0014 62.3426 24.0071 62.3492 24.0144 62.3538C24.0216 62.3584 24.03 62.3609 24.0385 62.3609C24.0471 62.3609 24.0555 62.3584 24.0627 62.3538C24.0699 62.3492 24.0756 62.3426 24.0792 62.3348L30.8499 48.5058C30.8541 48.4976 30.8556 48.4882 30.8542 48.4791C30.8529 48.4699 30.8487 48.4614 30.8423 48.4547C30.8359 48.448 30.8276 48.4434 30.8185 48.4417C30.8094 48.4399 30.8 48.441 30.7915 48.4448L19.5293 53.0992Z" fill="#9CB3A3"/><path d="M15.3212 26.6866L10.9435 35.6291C10.9409 35.6342 10.9394 35.6398 10.9391 35.6455H0C0 35.6419 0 35.6377 0 35.6332C0.000486167 35.6312 0.00146219 35.6285 0.00286484 35.6253C0.00426749 35.622 0.00607308 35.6182 0.0081474 35.6142L18.3992 0.0501933C18.4059 0.0375718 18.4158 0.0269918 18.428 0.0195846C18.4402 0.0121773 18.4542 0.00822127 18.4684 0.00813945C19.8657 0.00271315 21.7477 0 24.1145 0C26.4822 0 28.3646 0.00271315 29.7619 0.00813945C29.7762 0.00822127 29.7901 0.0121773 29.8023 0.0195846C29.8145 0.0269918 29.8245 0.0375718 29.8311 0.0501933L48.2235 35.6128C48.2256 35.6169 48.2274 35.6206 48.2288 35.6239C48.2302 35.6272 48.2312 35.6299 48.2317 35.6318C48.2317 35.6363 48.2317 35.6404 48.2317 35.644C48.2317 35.6445 48.2317 35.6451 48.2317 35.6455H37.044C37.0435 35.6379 37.041 35.6305 37.0366 35.6242C37.0318 35.6172 37.0249 35.6118 37.0169 35.6088L15.3754 26.6662C15.3655 26.662 15.3543 26.6618 15.3442 26.6655C15.3341 26.6693 15.3259 26.6769 15.3212 26.6866ZM19.5076 18.1374C19.5049 18.1426 19.5033 18.1483 19.5029 18.1542C19.5026 18.16 19.5035 18.1659 19.5055 18.1714C19.5076 18.1769 19.5107 18.1819 19.5148 18.1861C19.5189 18.1903 19.5238 18.1936 19.5293 18.1957L30.7983 22.8529C30.8064 22.8565 30.8153 22.8575 30.8239 22.8557C30.8325 22.854 30.8404 22.8496 30.8464 22.8432C30.8524 22.8367 30.8562 22.8286 30.8573 22.8198C30.8584 22.8111 30.8568 22.8023 30.8526 22.7945L24.0765 8.95611C24.0731 8.94893 24.0677 8.94286 24.061 8.93861C24.0543 8.93436 24.0465 8.93211 24.0385 8.93211C24.0306 8.93211 24.0228 8.93436 24.0161 8.93861C24.0093 8.94286 24.004 8.94893 24.0005 8.95611L19.5076 18.1374Z" fill="#1B3528"/></svg>',
			),
		scaledSize: new google.maps.Size(39, 58),
		anchor: new google.maps.Point(20, 58),
	};

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	function initMap($el) {
		// Find marker elements within map.
		var $markers = $el.find(".marker");

		// Create generic map.
		var defaultZoom = parseInt($el.data("zoom"), 10) || 14;
		var mapArgs = {
			zoom: defaultZoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true, // optional but recommended for footer
			styles: [
				{ elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
				{ elementType: "labels.icon", stylers: [{ visibility: "off" }] },
				{ elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
				{ elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
				{
					featureType: "administrative",
					elementType: "geometry",
					stylers: [{ color: "#c9c9c9" }],
				},
				{
					featureType: "administrative.country",
					elementType: "labels.text.fill",
					stylers: [{ color: "#616161" }],
				},
				{
					featureType: "administrative.land_parcel",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "administrative.locality",
					elementType: "labels.text.fill",
					stylers: [{ color: "#757575" }],
				},
				{
					featureType: "poi",
					elementType: "geometry",
					stylers: [{ color: "#eeeeee" }],
				},
				{
					featureType: "poi",
					elementType: "labels.text.fill",
					stylers: [{ color: "#757575" }],
				},
				{
					featureType: "poi.park",
					elementType: "geometry",
					stylers: [{ color: "#e5e5e5" }],
				},
				{
					featureType: "poi.park",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9e9e9e" }],
				},
				{
					featureType: "poi.park",
					elementType: "labels.text.stroke",
					stylers: [{ color: "#f5f5f5" }],
				},
				{
					featureType: "road",
					elementType: "geometry.fill",
					stylers: [{ color: "#ffffff" }],
				},
				{
					featureType: "road",
					elementType: "labels.text.fill",
					stylers: [{ color: "#8a8a8a" }],
				},
				{
					featureType: "road.arterial",
					elementType: "geometry",
					stylers: [{ color: "#ffffff" }],
				},
				{
					featureType: "road.highway",
					elementType: "geometry",
					stylers: [{ color: "#dadada" }],
				},
				{
					featureType: "road.highway.controlled_access",
					elementType: "geometry",
					stylers: [{ color: "#e5e5e5" }],
				},
				{
					featureType: "road.local",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9e9e9e" }],
				},
				{
					featureType: "transit",
					elementType: "labels.text.fill",
					stylers: [{ color: "#757575" }],
				},
				{
					featureType: "transit.line",
					elementType: "geometry",
					stylers: [{ color: "#e5e5e5" }],
				},
				{
					featureType: "transit.station",
					elementType: "geometry",
					stylers: [{ color: "#eeeeee" }],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [{ color: "#c9c9c9" }],
				},
				{
					featureType: "water",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9e9e9e" }],
				},
			],
		};
		var map = new google.maps.Map($el[0], mapArgs);
		map.defaultZoom = defaultZoom;

		// Add markers.
		map.markers = [];
		$markers.each(function () {
			initMarker($(this), map);
		});

		// Center map based on markers.
		centerMap(map);

		// Return map instance.
		return map;
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	function initMarker($marker, map) {
		// Get position from marker.
		var lat = $marker.data("lat");
		var lng = $marker.data("lng");
		var latLng = {
			lat: parseFloat(lat),
			lng: parseFloat(lng),
		};

		// Create marker instance.
		var marker = new google.maps.Marker({
			position: latLng,
			map: map,
			// Custom SVG Icon
			icon: svgMarker,
		});

		// Append to reference for later use.
		map.markers.push(marker);

		// If marker contains HTML, add it to an infoWindow.
		if ($marker.html()) {
			// Create info window.
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, "click", function () {
				infowindow.open(map, marker);
			});
		}
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	function centerMap(map) {
		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function (marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			});
		});

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(map.defaultZoom || 14);

			// Case: Multiple markers.
		} else {
			map.fitBounds(bounds);
		}
	}

	// Render maps on page load.
	$(document).ready(function () {
		$(".acf-map").each(function () {
			var map = initMap($(this));
		});
	});
});
